import {
  Typography,
  Box,
  Stack
} from '@mui/material';

import React from 'react';
import { appFormUtil } from 'modules/common';
import { StyledFileUploadField } from 'modules/components/layer01';



export type UploadDocumentFieldFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: UploadDocumentFieldFieldProps<T>) => {
  const fieldProps = props.form.genFieldProps(props.fieldName);
  return (
    <StyledFileUploadField.FC
      form={props.form}
      formFieldPropertyName={props.fieldName}
      required={fieldProps.required}
      formLabel='Upload a File'
    >
      <Stack
        direction='column'
        rowGap='1rem'
        justifyContent='center'
      >
        <Box
          component='span'
        >
          <Typography
            color='red'
          >Click to upload a file
          </Typography>
          <Typography>or drag and drop</Typography>
        </Box>

      </Stack>
    </StyledFileUploadField.FC>
  );
};
